import React, { ChangeEvent, type FC, useCallback } from 'react';
import { getIn, useFormikContext } from 'formik';
import { Switch, SwitchProps } from '../Switch';
import { useAppFormControlContext } from './appFormControlContext';
import { appFormDataTestFactory } from './appFormDataTestFactory';

export const AppFormSwitch: FC<SwitchProps> = (props) => {
  const context = useAppFormControlContext();
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const name = 'name' in props ? props.name : context.name;
  const value = 'checked' in props ? props.checked : name ? getIn(values, name) : undefined;
  const onChange = props.onChange;
  const handleOnChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(e, !value);
      } else if (name) {
        setFieldTouched(name);
        setFieldValue(name, !value);
      }
    },
    [name, onChange, setFieldTouched, setFieldValue, value]
  );
  return (
    <Switch
      size="small"
      {...props}
      checked={value}
      onChange={handleOnChange}
      data-test={appFormDataTestFactory(props.dataTest ?? context.dataTest).input}
    />
  );
};
